exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SuccessAlert {\n  display: inline-block;\n  margin-right: 20px;\n}\n", ""]);

// exports
